import gsap from 'gsap';

const open = gsap.timeline({
    paused: true,
});

open
    .staggerTo('.collapse', 0.4, {
        opacity: 1,
        ease: "easeInOut",
        display:"block",
    }, 0.1)
    .staggerTo('.header__menu .animated-menu-item', 0.5, {
        x: 0,
        opacity: 1,
        ease: "easeInOut",
    }, 0.1)
    .to('.collapse__beeldmerk', 0.5, {
        y: 0,
        ease: "easeInOut",
    }, '<')
    .to('.collapse__wrapper__contact', 0.6, {
        opacity: 1,
        y: 0,
        ease: "easeInOut",
    }, '<')
    .to('.collapse__close', 0.4, {
        opacity: 1,
        ease: "easeInOut",
    }, '<')

const close = gsap.timeline({
    paused: true,
});

close
    .staggerTo('.collapse__close', 0.2, {
        opacity: 0,
        ease: "easeInOut",
    })
    .to('.collapse__beeldmerk', 0.3, {
        y: 200,
        ease: "easeInOut",
    }, '<')
    .to('.collapse__wrapper__contact', 0.4, {
        opacity: 1,
        y: 200,
        ease: "easeInOut",
    }, '<')
    .staggerTo('.header__sub-menu', 0.3, {
        y: 100,
        opacity: 0,
        ease: "easeInOut",
    },'0.1', '<')
    .staggerTo('.header__menu .animated-menu-item', 0.1, {
        x: 100,
        opacity: 0,
        ease: "easeInOut",
    }, '0.1', '<')
    .staggerTo('.collapse', 0.3, {
        x: 0,
        opacity: 0,
        ease: "easeInOut",
        display:"none",
    }, '<')

const timelineToggle = (timeline) => {
    if(timeline.progress() < 1){
        timeline.play();
    } else {
        timeline.restart();
    }
}

const menuScroll = () => {
    if(window.innerWidth < 767) {
        if($('.navbar-toggler').hasClass('active')) {
            window.scroll_position = $(window).scrollTop();
            $('body')
                .css('position', 'fixed')
                .css('overflow', 'hidden')
                .css('width', '100%');
        } else {
            $('body')
                .css('position', '')
                .css('overflow', '')
                .css('width', 'auto');
            $(window).scrollTop(window.scroll_position);
        }
    }
}

const removeItems = () => {
    const close = gsap.timeline({
        paused: true,
    });

    close
        .staggerTo('.sub-menu .nav-item', 0.3, {
            opacity: 0,
            ease: "easeInOut",
        }, 0.05);

    close.play();

    setTimeout(() => {
        $('.sub-menu').html('');
    }, 700);
}

$('.navbar-toggler').on('click', function() {
    if( $(this).hasClass('toggleClose')) {
        removeItems();
        timelineToggle(close);
    } else {
        timelineToggle(open);
    }
    menuScroll();
});

$(document).keydown(function(event) {
    if (event.keyCode == 27) {
        if( $('.collapse').is(":visible") ) {
            removeItems();
            timelineToggle(close);
            menuScroll();
        }
    }
});
